<script setup>
import ResponsiveView from "@/components/helper/ResponsiveView.vue";
import QuizMobile from "@/components/quiz/QuizMobile.vue";
import QuizSidebarMobile from "@/components/quiz/QuizSidebarMobile.vue";
</script>

<template>
  <ResponsiveView mobile-only>
    <QuizMobile />
  </ResponsiveView>
  <ResponsiveView desktop-only>
    <QuizSidebarMobile />
  </ResponsiveView>
</template>
